import { render } from "./InvoiceFortnox.vue?vue&type=template&id=b80c84d2&scoped=true"
import script from "./InvoiceFortnox.vue?vue&type=script&lang=js"
export * from "./InvoiceFortnox.vue?vue&type=script&lang=js"

import "./InvoiceFortnox.vue?vue&type=style&index=0&id=b80c84d2&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b80c84d2"]])

export default __exports__